import { useQuery } from "@tanstack/vue-query";

export default function useRouteCodesQuery() {
    const fetcher = () => {
        return [
	        { label: 'Dublin - Holyhead', value: 'DUBHOL' },
	 		{ label: 'Holyhead - Dublin', value: 'HOLDUB' },
	 		{ label: 'Rosslare - Pembroke', value: 'ROSPEM' },
	 		{ label: 'Pembroke - Rosslare', value: 'PEMROS' },
	 		{ label : 'Dublin - Cherbourg', value: 'DUBCHE' },
	 		{ label: 'Cherbourg - Dublin', value: 'CHEDUB' },
	 		{ label: 'Dover - Calais', value: 'DOVCAL' },
	 		{ label: 'Calais - Dover', value: 'CALDOV' }
        ];
    };

    return {
        ...useQuery({
            queryKey: ["routeCodes"],
            queryFn: fetcher,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60,
        }),
    };
}
